import { FiX } from "react-icons/fi";
import Modal from "../modal";

type BrowseNewFolderModalProps = {
  show: boolean;
  newFolderName: string;
  onChange: (value: string) => void;
  onClose: () => void;
  onCreate: () => void;
};

const BrowseNewFolderModal = ({
  show,
  newFolderName,
  onChange,
  onClose,
  onCreate,
}: BrowseNewFolderModalProps) => {
  if (!show) return null;

  return (
    <Modal
      isOpen={show}
      onClose={onClose}
      panelClassName="rounded-lg shadow-xl w-96 mx-4 bg-white"
    >
      <div className="flex items-center justify-between p-6 border-b border-gray-200">
        <h2 className="text-lg font-semibold">New Folder</h2>
        <button
          onClick={onClose}
          className="p-1 rounded-full transition-colors hover:bg-gray-100"
        >
          <FiX size={20} />
        </button>
      </div>
      <div className="p-6">
        <input
          type="text"
          value={newFolderName}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") onCreate();
            if (e.key === "Escape") onClose();
          }}
          placeholder="Folder name"
          className="w-full px-3 py-2 rounded-lg text-sm focus:outline-none focus:border-blue-500 bg-white border border-gray-300"
          autoFocus
        />
      </div>
      <div className="flex items-center justify-end space-x-3 p-6 border-t border-gray-200">
        <button
          onClick={onClose}
          className="px-4 py-2 rounded-lg text-sm transition-colors bg-gray-200 hover:bg-gray-300 text-gray-800"
        >
          Cancel
        </button>
        <button
          onClick={onCreate}
          disabled={!newFolderName.trim()}
          className={`px-4 py-2 rounded-lg text-sm transition-colors ${
            newFolderName.trim()
              ? "bg-blue-600 hover:bg-blue-700 text-white"
              : "bg-gray-400 opacity-50 cursor-not-allowed"
          }`}
        >
          Create
        </button>
      </div>
    </Modal>
  );
};

export default BrowseNewFolderModal;
